import { useEffect } from 'react'

import { Credits } from '../Common/Credits/Credits'
import { GoToBack } from './../Common/GoToBack'


const Download = () => {

    useEffect(() => {
        document.body.classList.add('BodyComplete')
        document.body.classList.add('Background--Ztudia')
        
        return ()  => {
            document.body.classList.remove('Background--Ztudia')
        }
    }, [])
    

    return (
        <>
            <header className="container Header">
                <div className="Header-Side1">
                    <div className="Header-Brand">
                        <img src="./img/brand/Ztudia-Logotipo-Negro-66x26.png" alt="Logotipo-Ztudia" className="Header-Image" />
                    </div>
                </div>

                <div className="Header-Side2"></div>
                
                <div className="Header-Side3"></div>
            </header>

            <main className="Download container Container-FullHeight Fonts--PlusJakartaSans">
                <GoToBack url={'/'} />
                
                <img src="./img/brand/Ztudia-Logotipo-Negro-350x135.png" alt="Logotipo-Ztudia" className="Download__Logo" />
                <p className='Download__Text--Center'>Descarga la solución Ztudia para comenzar tu proceso de certificación</p>

                <div className='Download__Tiles'>
                    <div className='Download__Tiles__Item'>
                        <i className="bi bi-windows Download__Tiles__Item__Icon"></i>
                        <p className="Download__Text--Center">Ztudia para Microsoft Windows</p>
                        <a className="Btn__Ztudia--Primary Download__Tiles__Item__Button" href="./files/download/ztudiaappforw.zip" download><i className="bi bi-download"></i> Descargar ahora</a>
                    </div>

                    <div className='Download__Tiles__Item'>
                        <i className="bi bi-apple Download__Tiles__Item__Icon"></i>
                        <p className="Download__Text--Center">Ztudia para Mac</p>
                        <a className="Btn__Ztudia--PrimaryOutline Download__Tiles__Item__Button" href="./files/download/ztudiaappform.zip" download><i className="bi bi-download"></i> Descargar ahora</a>
                    </div>
                </div>
            </main>

            <Credits />
        </>
    )
}

export { Download };